module.exports = __webpack_public_path__ + "static/media/ic_goal_active.edf2a704.svg";